import { render } from "./App.vue?vue&type=template&id=a7b88e48"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a7b88e48&lang=css"

import exportComponent from "/home/hans/projecten/werkmap_klompenmuseum/software/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__